import { computed } from "vue";
import { KeyReturnAdrKb, KeyReturnNameKb, RenrakuKb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
export function useTaikyoTableColumns(taikyo, isMultipleKeiyaku, isMMA, filteredInput, options = {}) {
    const { showDelete = false, showPrecautions = false, keyReturnAdrWidth = "240px", emailWidth = "240px" } = options;
    return computed(() => {
        const inputList = filteredInput.value;
        return [
            ...(showDelete
                ? [
                    {
                        name: "delete",
                        label: "",
                        visible: isMultipleKeiyaku,
                        align: "center",
                        classes: "q-table--col-auto-width"
                    }
                ]
                : []),
            {
                name: "bukkenName",
                field: "bukkenName",
                label: "物件名",
                align: "left",
                classes: "q-table--col-auto-width"
            },
            {
                name: "roomNumber",
                field: "roomNumber",
                label: "号室",
                align: "left",
                classes: "q-table--col-auto-width"
            },
            {
                name: "nyukyosha",
                field: "nyukyosha",
                label: "入居者名",
                align: "left",
                classes: "q-table--col-auto-width"
            },
            {
                name: "taikyoYmd",
                field: "taikyoYmd",
                label: "退去予定日",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px"
            },
            {
                name: "kaiyakuYmd",
                field: "kaiyakuYmd",
                label: "解約日",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px"
            },
            {
                name: "taikyoRiyuKb",
                field: "taikyoRiyuKb",
                label: "退去理由",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px"
            },
            {
                name: "taikyoRiyu",
                field: "taikyoRiyu",
                label: "退去理由の詳細",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: taikyo.taikyoList.some(x => x.taikyoRiyuKb != null &&
                    ([TaikyoRiyuKb.Other].includes(x.taikyoRiyuKb) ||
                        [TaikyoRiyuKb.DissatisfactionOrTrouble].includes(x.taikyoRiyuKb)))
            },
            {
                name: "sonotaKeiyaku",
                field: "sonotaKeiyaku",
                label: "その他ご契約事項",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: filteredInput.value.some(x => [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyReturnScheduledDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "renrakuKb",
                field: "renrakuKb",
                label: "連絡先",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                align: "left"
            },
            {
                name: "renrakuName",
                field: "renrakuName",
                label: "氏名",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: taikyo.taikyoList.some(x => x.renrakuKb === RenrakuKb.Other)
            },
            {
                name: "renrakuRelationship",
                field: "renrakuRelationship",
                label: "入居者との関係性",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: taikyo.taikyoList.some(x => x.renrakuKb === RenrakuKb.Other)
            },
            {
                name: "tel",
                field: "tel",
                label: "電話番号",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: taikyo.taikyoList.some(x => x.renrakuKb === RenrakuKb.Hojin ||
                    x.renrakuKb === RenrakuKb.Nyukyosha ||
                    x.renrakuKb === RenrakuKb.Other)
            },
            {
                name: "email",
                field: "email",
                label: "メールアドレス",
                align: "left",
                style: `min-width: ${emailWidth}`,
                headerStyle: `min-width: ${emailWidth}`,
                visible: taikyo.taikyoList.some(x => x.renrakuKb === RenrakuKb.Hojin ||
                    x.renrakuKb === RenrakuKb.Nyukyosha ||
                    x.renrakuKb === RenrakuKb.Other)
            },
            {
                name: "keyReturnYmd",
                field: "keyReturnYmd",
                label: "退去に関する日程",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: !isMMA
            },
            ...(showPrecautions
                ? [
                    {
                        name: "precautions",
                        field: "precautions",
                        label: "",
                        align: "left",
                        visible: !isMMA &&
                            filteredInput.value.some(x => [KeyReturnNameKb.PreferredAttendanceDatetime].includes(x.keyReturnNameKb))
                    }
                ]
                : []),
            {
                name: "numberOfReturnKeys",
                field: "numberOfReturnKeys",
                label: "鍵返却予定数",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: !isMMA &&
                    filteredInput.value.some(x => [Number(KeyReturnNameKb.PreferredAttendanceDatetime), Number(KeyReturnNameKb.KeyReturnScheduledDatetime)].includes(x.keyReturnNameKb))
            },
            {
                name: "shopName",
                field: "shopName",
                label: "鍵返却予定店舗",
                align: "left",
                style: "min-width: 300px",
                headerStyle: "min-width: 300px",
                visible: !isMMA &&
                    filteredInput.value.some(x => [KeyReturnNameKb.KeyReturnScheduledDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "selectedTachiaishaKbn",
                field: "selectedTachiaishaKbn",
                label: "退去立会者",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: !isMMA &&
                    filteredInput.value.some(x => [KeyReturnNameKb.PreferredAttendanceDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "taikyoTachiaiName",
                field: "taikyoTachiaiName",
                label: "退去立会者名",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: !isMMA &&
                    filteredInput.value.some(x => [KeyReturnNameKb.PreferredAttendanceDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "keyReturnAdrKb",
                field: "keyReturnAdrKb",
                label: "鍵封筒送付先",
                align: "left",
                style: `min-width: ${keyReturnAdrWidth}`,
                headerStyle: `min-width: ${keyReturnAdrWidth}`,
                visible: filteredInput.value.some(x => [KeyReturnNameKb.KeyReturnScheduledDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "soufuName",
                field: "soufuName",
                label: "氏名",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha)
            },
            {
                name: "postCode",
                field: "postCode",
                label: "郵便番号",
                align: "left",
                style: "min-width: 240px",
                headerStyle: "min-width: 240px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Hojin || x.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha)
            },
            {
                name: "adr1",
                field: "adr1",
                label: "県市区町村",
                align: "left",
                style: "min-width: 300px",
                headerStyle: "min-width: 300px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Hojin || x.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha)
            },
            {
                name: "adr2",
                field: "adr2",
                label: "番地",
                align: "left",
                style: "min-width: 300px",
                headerStyle: "min-width: 300px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Hojin || x.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha)
            },
            {
                name: "adr3",
                field: "adr3",
                label: "建物名号室",
                align: "left",
                style: "min-width: 300px",
                headerStyle: "min-width: 300px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Hojin || x.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha)
            },
            {
                name: "soufuSonota",
                field: "soufuSonota",
                label: "自由記入",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: taikyo.taikyoList.some(x => x.keyReturnAdrKb === KeyReturnAdrKb.Other)
            },
            {
                name: "hasonFile",
                field: "hasonFile",
                label: "破損・汚損申告",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: !isMMA &&
                    filteredInput.value.some(x => [KeyReturnNameKb.KeyReturnScheduledDatetime].includes(x.keyReturnNameKb))
            },
            {
                name: "otherFile",
                field: "otherFile",
                label: "破損・汚損以外の添付ファイル",
                align: "left",
                style: "min-width: 480px",
                headerStyle: "min-width: 480px",
                visible: !isMMA
            }
        ];
    });
}
